export const CHANGE_GEOINFO_lRN = 'CHANGE_GEOINFO_lRN';
export const CHANGE_MODELDEP_lRN = 'CHANGE_MODELDEP_lRN';

export function changeGeoInfoAction(value) {
    return {
        type: CHANGE_GEOINFO_lRN,
        value: value
    };
}

export function changeModelDepAction(value) {
    return {
        type: CHANGE_MODELDEP_lRN,
        value: value
    };
}